<template>
  <div>
    <div v-if="$root.$i18n.locale === 'en'" class="error">
      <h3>Translation Missing</h3>
      <p>We apologize that this page has not been translated yet.</p>
    </div>
    <div class="hotspot-frame">
      <img src="../assets/mlc__19121802.jpg" width="100%">
      <hotspot x="46%" y="20%">
        <template slot="title">Käfige</template>
        <template slot="details">Für die Pausen zwischendurch</template>
      </hotspot>
      <hotspot x="51.5%" y="16%">
        <template slot="title">Andreaskreuz</template>
        <template slot="details">Für die besonders Frechen unter euch</template>
      </hotspot>
      <hotspot x="58%" y="11%">
        <template slot="title">Isolationsbox</template>
        <template slot="details">Und schon hat man seine Ruhe...</template>
      </hotspot>
      <hotspot x="70%" y="17%">
        <template slot="title">Kuschelecke</template>
        <template slot="details">Wunden lecken oder einfach so entspannen.</template>
      </hotspot>
      <hotspot x="64%" y="21%">
        <template slot="title">Bondage Stuhl</template>
        <template slot="details">Halt mal kurz still.</template>
      </hotspot>
      <hotspot x="56%" y="34%">
        <template slot="title">Dusche</template>
        <template slot="details">Nicht nur sauber, sondern rein.</template>
      </hotspot>
      <hotspot x="50%" y="38%">
        <template slot="title">WC</template>
        <template slot="details">Wofür war das nochmal?</template>
      </hotspot>
      <hotspot x="28%" y="36%">
        <template slot="title">Umkleide</template>
        <template slot="details">Raus aus den Straßenklamotten!</template>
      </hotspot>
      <hotspot x="46%" y="64%">
        <template slot="title">Bällebad</template>
        <template slot="details">Lasst die Kinder spielen. Was kann schon passieren?</template>
      </hotspot>
      <hotspot x="35%" y="77%">
        <template slot="title">Bar</template>
        <template slot="details">Was raus muss, muss irgendwo rein.</template>
      </hotspot>
      <hotspot x="71%" y="69%">
        <template slot="title">Raucherbereich</template>
        <template slot="details">Darf er das überhaupt?</template>
      </hotspot>
      <hotspot x="86%" y="52%">
        <template slot="title">Trickfilmecke</template>
        <template slot="details">Psst, ich will das sehen!</template>
      </hotspot>
    </div>
    <article class="accent-volth">
      <header>
        <h3>Eingang, Umkleide, Duschen und WC's</h3>
      </header>
      <main>
        <p>
          Macht euch in der Umkleide bereit für die Party. Auf Höhe der Umkleide befinden sich auch die Duschen und WC's zum
          frisch machen. Ihr könnt euer Partygepäck in euren persönlichen
          Spinden aufbewahren. Da ihr eure Bewirtung im Partybereich mit eurem Armband abrechnet, könnt ihr getrost auch
          eure Wertsachen für den Abend wegschließen. Nach dem Umziehen folgt der Dresscode-Check.
        </p>
      </main>
    </article>
    <article class="accent-volth">
      <header>
        <h3>
          Erdgeschoss
        </h3>
      </header>
      <main>
        <p>
          Von der Umkleide führt eine Treppe direkt zur Party im Erdgeschoss. Von dort aus erreicht ihr auch die
          verschiedenen Bereiche.
        </p>
        <h4>Barbereich</h4>
        <p>
          An der gut sortierten Bar wird den ganzen Abend über für euer leibliches Wohl gesorgt. Dort könnt ihr euch
          mit Getränken und kleinen Snacks versorgen lassen. Die Preise hierfür sind sehr moderat gehalten. Die gemütliche
          Einrichtung lädt zum Quatschen und Plaudern ein.
        </p>
        <h4>Spielbereiche</h4>
        <p>
          Im Erdgeschoss findet ihr außerdem die "braven" Spielbereiche, wie das Bällebad zum Herumalbern und die
          Trickfilmecke
          zum Entspannen.
        </p>
      </main>
    </article>
    <article class="accent-volth">
      <header>
        <h3>Obergeschoss</h3>
      </header>
      <main>
      <p>
        Gegenüber der Umkleide befindet sich über den Zugang im Erdgeschoss der SM-Bereich für die "schwierigen Fälle".
        Dort könnt ihr eure Erziehungsmaßnahmen in vollem Rahmen durchführen, es stehen hierzu Andreaskreuze (stehend oder
        drehbar), eine Isolationskammer, ein Bondage-Stuhl und verschiedene Käfige zur Verfügung.
        Wenn ihr euch anschließend wieder benehmen könnt, bietet die Kuschelecke Raum für den gemütlichen Teil des Abends.
      </p>
      </main>
    </article>
  </div>
</template>


<script>
  import Hotspot from '../components/Hotspot'

  export default {
    components: {Hotspot}
  }
</script>


<style scoped lang="scss">
  $colorMain: #1976d2;
  $colorAccent: #fdd835;

  .hotspot-frame {
    position: relative;
    margin-bottom: 2em;

    img {
      border-radius: 8px;
    }

    .hotspot {
      position: absolute;

      .content {
        display: none;
      }
    }
  }
</style>
